/**
 * Created by showzyl on 2017/9/26
 *
 * 与`sdk`交互封装
 * 所有名为xxxxForSplash的方法为专为开屏广告模板写入的封装，仅更换了sClass
 */

'use strict'

import util from 'common/js/util.js'
import $ from 'jquery'

import {
  handleData
} from 'components/handledata.js'
// import { data } from 'common/js/data.js'


let $body = $('body')
let campaignMap = {}

let common = {

  /**
   * 获取广告 init
   */
  getInfo () {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'init',
      params: {},
      succ: function (res) {
        if (res.campaignList && res.campaignList.length) {
          // 替换`http`到`https`
          if (location.protocol === 'https:') {
            util.http2https(res)
          }

          // 缓存`campaign`
          let campaign = res.campaignList[0]
          campaignMap[campaign['id']] = campaign;
          $body.attr('campaignId', campaign.id)
          $body.attr('unitId', res.unitSetting.unitId)
          $body.data('data', JSON.stringify(res))

          // util.createEl(JSON.stringify(res), 'getInfo')
          handleData(res);
          // 第一行触发jquery创建的监听器
          // 第二行触发原生监听器
          $(document).trigger('getInfoSuccess', res)
          window.WindVane.fireEvent('getInfoSuccess', res);
        } else {
          util.noDataTips()
        }

      },
      err: function (err) {
        util.tips('Sorry, network error...')
        common.toggleCloseBtn()
      }
    })
  },

  getInfoForSplash () {
    util.hybirdEvent({
      sClass: 'SplashJs',
      hybirdFn: 'init',
      params: {},
      succ: function (res) {
        if (res.campaignList && res.campaignList.length) {
          // 替换`http`到`https`
          if (location.protocol === 'https:') {
            util.http2https(res)
          }

          // 缓存`campaign`
          let campaign = res.campaignList[0]
          campaignMap[campaign['id']] = campaign;
          $body.attr('campaignId', campaign.id)
          $body.attr('unitId', res.unitSetting.unitId)
          $body.data('data', JSON.stringify(res))

          // 第一行触发jquery创建的监听器
          // 第二行触发原生监听器
          $(document).trigger('getInfoSuccess', res)
          window.WindVane.fireEvent('getInfoSuccess', res);
        } else {
          util.noDataTips()
        }

      },
      err: function (err) {
        util.tips('Sorry, network error...')
        common.toggleCloseBtn()
      }
    })
  },

  /**
   * 点击 js 调 native
   * @param type `1`是安装 `2`是关闭
   * @param cb
   */
  click (type = 1, cb) {
    var _data = JSON.parse($('body').data('data'));
    _params = _data.campaignList[0];

    if (util.device().isAndroid) {
      _params = util.getParams2Native(_params);
    }

    try {
      if (res || event) {

        let clickPosition;
        let click_senario;

        if (res) {
          let pt = (typeof res.pt === 'string') ? JSON.parse(res.pt || '{}') : res.pt;
          clickPosition = {
            x: pt.cta_click_info.click_x,
            y: pt.cta_click_info.click_y
          };//util.getMousePosition(e);
          click_senario = pt.cta_click_info.click_senario;
        } else {

          clickPosition = util.getMousePosition(event);
          click_senario = 0;//正常点击
          //document.getElementById('testdiv').innerHTML = JSON.stringify(clickPosition);
        }

        // click_url 替换
        const _scale = _data.device.scale || window.devicePixelRatio;
        const cdnate_cfg = _data.appSetting.cdnate_cfg;
        let device_width = _data.device.screen_width;
        let device_height = _data.device.screen_height;

        clickPosition.x = clickPosition.x * _scale;
        clickPosition.y = clickPosition.y * _scale;

        if (click_senario == 2) {
          clickPosition.x = -999;
          clickPosition.y = -999;
        }

        if (util.device().isiOS) {
          device_width = _data.device.device_width * _scale;
          device_height = _data.device.device_height * _scale;
        }

        let click_url = _data.campaignList[0].click_url;
        let rel = /.+:\/\/(.*?)\//;
        let relhost = rel.exec(click_url)
        let host = relhost ? relhost[1] : '';
        let tar = {
          x: parseInt(clickPosition.x),
          y: parseInt(clickPosition.y),
          width: parseInt(device_width || window.screen.width),
          height: parseInt(device_height || window.screen.height)
        }

        if (cdnate_cfg && cdnate_cfg[host]) {
          let item = cdnate_cfg[host];
          for (let k in item) {
            let arr = item[k]
            for (let i = 0; i < arr.length; i++) {
              click_url = click_url.replace(new RegExp(arr[i], 'g'), tar[k])
            }
          }
        }

        _params.click_url = click_url
        console.log('我是click_url: ', _params.click_url)


        // 以下是noticeurl
        let ori = util.getGlobalData('ori') || 0
        let click_scale = util.getGlobalData('click_scale');

        let notice_url = _params.notice_url;
        notice_url = util.delParam(_params.notice_url, 'click_x');
        notice_url = util.delParam(notice_url, 'click_y');
        notice_url = util.delParam(notice_url, 'click_ori');
        notice_url = util.delParam(notice_url, 'click_senario');

        if (click_senario !== 2 && click_senario !== '2') {
          notice_url += `&click_x=${clickPosition.x}&click_y=${clickPosition.y}&click_ori=${ori}`;
        }
        if (util.device().isAndroid) {
          notice_url += `&click_scale=${click_scale}`;
        }
        notice_url += `&click_senario=${click_senario}`;
        _params.notice_url = notice_url

      }
    } catch (error) {

    }

    let params = {
      type: type,
      pt: _params
    }
    if (util.device().isiOS) {
      params = encodeURIComponent(JSON.stringify(params))
    }
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'click',
      params: params,
      succ: function (res) {
        //document.write(res);
        cb && cb(res)
      },
      err: function () {
        util.tips('Sorry, network error...')
      }
    });
  },

  /**
   * 页面关闭 - 如果 close_alert 为 1, 则 SDK 会在调用此方法时, 先展示一个原生的确认弹窗
   */
  triggerCloseBtn (state = 'click') {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'triggerCloseBtn',
      params: {
        state
      },
      succ: function (res) {
        //document.write(res);
        if (res && util.device().isAndroid) {

        } else {

        }
      },
      err: function () {
        util.tips('Sorry, network error...')
      }
    });
  },

  /**
   * 页面关闭 - 调用此方法关闭 webview 时, 即使 close_alert 为 1, SDK 也不会出确认弹窗
   * 注意:
   * 由于部分场景 (H5 渲染的关闭按钮) 会直接将此函数作为 DOM 事件的回调函数,
   * 所以当前方法的第一个入参可能会是一个 Event 对象,
   * 所以需要对这种情况做兼容处理 => state 暂时固定赋值为 click
   */
  triggerCloseBtnWithNoConfirm () {
    let state = 'click'
    util.hybirdEvent({
      sClass: 'RewardJs',
      hybirdFn: 'triggerCloseBtn',
      params: {
        state
      },
      succ: function (res) {
        //document.write(res);
        if (res && util.device().isAndroid) {

        } else {

        }
      },
      err: function () {
        util.tips('Sorry, network error...')
      }
    });
  },

  triggerCloseBtnWithNoConfirmForSplash () {
    let state = 'click'
    util.hybirdEvent({
      sClass: 'SplashJs',
      hybirdFn: 'triggerCloseBtn',
      params: {
        state
      },
      succ: function (res) {
        //document.write(res);
        if (res && util.device().isAndroid) {

        } else {

        }
      },
      err: function () {
        util.tips('Sorry, network error...')
      }
    });
  },

  /**
   * 获取当前进度
   * @param cb
   */
  getCurrentProgress (cb) {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'getCurrentProgress',
      params: {},
      succ: function (res) {
        // console.log('getCurrentProgress res: ', res)
        cb && cb(res)
        // 结束
        // if (res.time === res.duration) {
        //   cb(res)
        // }
      },
      err: function (err) {
        util.tips('Sorry, network error...')
      }
    })
  },

  /**
   * 设置`视频播放播放器`位置和大小
   * @param params
   * @param cb
   */
  showVideoLocation (params, cb) {
    console.log('showVideoLocation', JSON.stringify(params))
    // util.createEl(JSON.stringify(params) +'_' +(new Date).getTime(), 'showVideoLocation')
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'showVideoLocation',
      params: params,
      succ: function (res) {
        cb && cb(res)
      },
      err: function (err) {
        cb && cb('err')
      }
    })
  },

  /**
   * 是否关闭Video组件
   * @param close 1关闭video组件，其他值保持不变
   * @param view_visible 关闭按钮1隐藏，2展示，其他值为保持组件内默认值
   * @param cb
   */
  closeVideoOperte (close, view_visible, cb) {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'closeVideoOperte',
      params: {
        close,
        view_visible
      },
      succ: function (res) {
        cb && cb(res)
      },
      err: function (err) {
        cb && cb('err')
      }
    })
  },

  /**
   * 进度或倒计时控制
   * @param progress 0-100 当前进度，最大值为100 -1不做处理
   * @param view_visible 进度控件1隐藏，2展示，其他值为保持组件内默认值
   * @param cb
   */
  progressOperate (progress, view_visible, cb) {
    // alert('progressOperate: ' + progress)
    // alert('view_visible: ' + view_visible)
    // console.log('progressOperate', progress, view_visible)
    console.log('progressOperate: ', {
      progress,
      view_visible
    })
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'progressOperate',
      params: {
        progress,
        view_visible
      },
      succ: function (res) {
        cb && cb(res)
      },
      err: function (err) {
        cb && cb('err')
      }
    })
  },


  /**
   * IOS 控制下拉页面回弹
   *
   */
  toggleBounces (state = 0, cb) {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'toggleBounces',
      params: {
        state // 关闭反弹
      },
      succ: function (res) {
        cb && cb(res)
      },
      err: function () {

      }
    })
  },

  /**
   * 查询是否在前台
   * @param cb
   */
  isSystemResume (cb) {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'isSystemResume',
      params: {},
      succ: function (res) {
        cb && cb(res)
      },
      err: function () {
        cb && cb('err')
      }
    })
  },

  /**
   * 设置`storekit`位置和大小
   * @param params
   */
  showStorekit (params, cb) {
    console.log('showStorekitRect', JSON.stringify(params))
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'showStorekit',
      params: params,
      succ: function (res) {
        cb && cb(res)
      },
      err: function (err) {
        cb && cb('err')
      }
    })
  },

  /**
   * 声音
   * @param mute 1为静音 2为不静音
   * @param view_visible 1为隐藏 2为展示
   * @param pt 是否用户手动触发 '1'程序 '2'用户点击
   * @param cb 回调
   */
  soundOperate (mute, view_visible, pt = '1', cb) {
    console.log('soundOperate: ', {
      mute,
      view_visible,
      pt
    })

    util.createEl('soundOperate: ' + JSON.stringify({
      mute,
      view_visible,
      pt
    }))

    // console.log('mute: ' + mute)
    // console.log('view_visible: ' + view_visible)
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'soundOperate',
      params: {
        mute,
        view_visible,
        pt
      },
      succ: function (res) {
        // console.log(typeof res.code)
        if (res.code === 0) {
          cb && cb(res)
        } else {
          cb && cb('err', err)
        }
      },
      err: function (err) {
        cb && cb('err', err)
      }
    })
  },

  /**
   * 视频处理
   * @param pause_or_resume 1为播放 2为暂停
   * @param cb
   */
  videoOperate (pause_or_resume, cb) {
    console.log('videoOperate: ', {
      pause_or_resume
    })
    // // alert('pause_or_resume: ' + pause_or_resume)
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'videoOperate',
      params: {
        pause_or_resume
      },
      succ: function (res) {
        cb && cb(res)
      },
      err: function (err) {
        cb && cb('err')
      }
    })
  },

  /**
   * 关闭`video`组件
   * @param close 1为关闭video组件
   * @param closeViewVisible 关闭按钮 1为隐藏，2展示
   */
  closeVideoOperate (close, closeViewVisible) {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'closeVideoOperate',
      params: {
        close,
        closeViewVisible
      },
      succ: function (res) {
        console.log(JSON.stringify(res))
      },
      err: function (err) {
        console.log(JSON.stringify(err))
      }
    })
  },

  /**
   * 点击视频外区域展示`banner` or `miniwebview`
   * @param type
   * -1 都不展示
   * 1为 banner`cta`
   * 2为 `miniendcard`
   * 3为 `VAST`品牌广告浮窗
   * @param cb 回调
   */
  showVideoClickView (type = 1, cb) {
    // alert('showVideoClickView: 无参数')
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'showVideoClickView',
      params: {
        type
      },
      succ: function (res) {
        // console.log(JSON.stringify(res))
        cb && cb(res)
      },
      err: function (err) {
        console.log(JSON.stringify(err))
      }
    })
  },

  /**
   * 发送统计
   * @param param
   * @param cb
   */
  statistics (param, cb) {
    console.log('statistics: ', param)
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'statistics',
      params: param,
      succ: function (res) {
        // console.log(JSON.stringify(res))
        cb && cb(res)
      },
      err: function (err) {
        console.log(JSON.stringify(err))
      }
    })
  },

  /**
   * * 通知Native 视频播放完需要操作处理的业务
   * @param params type ：1 模板4播放完成大图替换播放位置，并且上报`noticeurl` 和 `clickurl`
   * @param cb
   */
  playVideoFinishOperate (params, cb) {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'playVideoFinishOperate',
      params: params,
      succ: function (res) {
        cb && cb(res)
      },
      err: function (err) {
        cb && cb('err')
      }
    })
  },

  /**
   * 设置全屏
   * @param fitxy: "1表示缩放，其他表示不变"
   * @param cb
   */
  setScaleFitXY (fitxy = 1, cb) {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'setScaleFitXY',
      params: {
        fitxy
      },
      succ: function (res) {
        cb && cb(res)
      },
      err: function (err) {
        cb && cb('err')
      }
    })
  },

  /**
   * 出现关闭按钮
   * @param state 1 为默认出现， 2 为隐藏
   * @param cb
   */
  toggleCloseBtn (state = 1, cb) {
    console.log('toggleCloseBtn: ', state)
    util.hybirdEvent({
      sClass: 'RewardJs',
      hybirdFn: 'toggleCloseBtn',
      params: {
        state // 出现
      },
      succ: function (res) {
        // alert(JSON.stringify(res))
        cb && cb(res)
      },
      err: function () {
        // util.tips('Sorry, network error...');
      }
    })
  },

  toggleCloseBtnForSplash (state = 1, cb) {
    console.log('toggleCloseBtn: ', state)
    util.hybirdEvent({
      sClass: 'SplashJs',
      hybirdFn: 'toggleCloseBtn',
      params: {
        state // 出现
      },
      succ: function (res) {
        // alert(JSON.stringify(res))
        cb && cb(res)
      },
      err: function () {
        // util.tips('Sorry, network error...');
      }
    })
  },

  /**
   * 处理h5异常，通知sdk
   * @param code
   * @param message
   * @param cb
   */
  handlerH5Exception (code = -1000, message, cb) {
    console.log('handlerH5Exception: ', {
      code,
      message
    })
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'handlerH5Exception',
      params: {
        code,
        message
      },
      succ: function (res) {
        cb && cb(res)
      },
      err: function () {
        // util.tips('Sorry, network error...');
      }
    })
  },

  handlerH5ExceptionForSplash (code = -1000, message, cb) {
    console.log('handlerH5Exception: ', {
      code,
      message
    })
    util.hybirdEvent({
      sClass: 'SplashJs',
      hybirdFn: 'handlerH5Exception',
      params: {
        code,
        message
      },
      succ: function (res) {
        cb && cb(res)
      },
      err: function () {
        // util.tips('Sorry, network error...');
      }
    })
  },

  isReadyStatus (isReady = 1, cb) {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'readyStatus',
      params: {
        isReady // 1 ready  2 not ready
      },
      succ: function (res) {
        if (res.code === 0) {
          cb && cb(res)
        }
      },
      err: function () {

      }
    })
  },

  isReadyStatusForSplash (isReady = 1, cb) {
    util.hybirdEvent({
      sClass: 'SplashJs',
      hybirdFn: 'readyStatus',
      params: {
        isReady // 1 ready  2 not ready
      },
      succ: function (res) {
        if (res.code === 0) {
          cb && cb(res)
        }
      },
      err: function () {
      }
    })
  },

  /**
   * 使用外部浏览器, 打开当前提供的 url
   * @param url 要打开的 url 地址
   */
  openUrl (url = '') {
    util.hybirdEvent({
      sClass: 'VideoBridge',
      hybirdFn: 'openURL',
      params: {
        type: 1,
        url: url
      },
      succ: function (res) {
        console.log(res)
      },
      err: function (err) {
        console.error(err)
        util.tips('Sorry, network error...');
      }
    })
  },

  /**
   * 获取 SDK RewardJS 的上下文
   * RewardJs 需要注意的版本兼容问题:
   * 1. Android 9.6.0 下根节点有 {campaignList, sdk_info, unit_id, appSetting, unitSetting}, 但没有 {device} 属性
   * 2. Android 8.13.0 下根节点只有 {campaignList, sdk_info, unit_id}, 没有 {appSetting, unitSetting, SDKSetting, device} 属性
   * @param succ 成功回调
   * @param err 失败回调
   * @param complete 无论成功或者失败都会执行的回调
   */
  // 通过 RewardJs getEndScreenInfo 获取到的 SDK 上下文缓存, 避免单次生命周期中重复获取造成的资源浪费
  REWARD_JS_CONTEXT_CACHE: undefined,
  getRewardJSContext ({
                        succ = () => {
                        },
                        err = () => {
                        },
                        complete = () => {
                        }
                      }) {
    if (common.REWARD_JS_CONTEXT_CACHE) {
      console.log('common: get VideoBridge Context: cached')
      succ(common.REWARD_JS_CONTEXT_CACHE)
      complete(common.REWARD_JS_CONTEXT_CACHE)
      return common.REWARD_JS_CONTEXT_CACHE
    } else {
      util.hybirdEvent({
        sClass: 'RewardJs',
        hybirdFn: 'getEndScreenInfo',
        params: {
          pageNo: 1,
          exclude_ids: []
        },
        succ: function (res) {
          console.log('common: get RewardJS Context success => ', res)
          common.REWARD_JS_CONTEXT_CACHE = res
          if (res && res.campaignList && res.campaignList.length) {
            succ(res)
          } else {
            util.noDataTips()
          }
          complete(res)
        },
        err: function (err) {
          console.error('common: get RewardJS Context error', err)
          err(err)
          complete(err)
        }
      })
    }
  },

  /**
   * 获取 SDK VideoBridge 的上下文
   * VideoBridge 需要注意的版本兼容问题:
   * 1. Android 9.6.0 下根节点有 {campaignList, appSetting, unitSetting, device, sdkSetting}, 但没有 {sdk_info, unit_id} 属性
   * 2. Android 8.13.0 下根节点只有 {campaignList, sdk_info, unitSetting, device, sdkSetting}, 没有 {appSetting, unit_id} 属性
   * @param succ 成功回调
   * @param err 失败回调
   * @param complete 无论成功或者失败都会执行的回调
   */
  // 通过 VideoBridge init 获取到的 SDK 上下文缓存, 避免单次生命周期中重复获取造成的资源浪费
  VIDEO_BRIDGE_CONTEXT_CACHE: undefined,
  getVideoBridgeContext ({
                           succ = () => {
                           },
                           err = () => {
                           },
                           complete = () => {
                           }
                         }) {
    if (common.VIDEO_BRIDGE_CONTEXT_CACHE) {
      console.log('common: get VideoBridge Context: cached')
      succ(common.VIDEO_BRIDGE_CONTEXT_CACHE)
      complete(common.VIDEO_BRIDGE_CONTEXT_CACHE)
      return common.VIDEO_BRIDGE_CONTEXT_CACHE
    } else {
      console.log('common: get VideoBridge Context: no cache')
      util.hybirdEvent({
        sClass: 'VideoBridge',
        hybirdFn: 'init',
        params: {
          pageNo: 1,
          exclude_ids: []
        },
        succ: function (res) {
          console.log('common: get VideoBridge Context: success', res)
          common.VIDEO_BRIDGE_CONTEXT_CACHE = res
          if (res && res.campaignList && res.campaignList.length) {
            succ(res)
          } else {
            util.noDataTips()
          }
          complete(res)
        },
        err: function (err) {
          console.warn('common: get VideoBridge Context: error', err)
          err(err)
          complete(err)
        }
      })
    }
  },

  /**
   * 暂停页面，切换出`app`
   * @param cb
   */
  onSystemPause (cb) {
    document.addEventListener('onSystemPause', function (res) {
      console.log('onSystemPause res: ', res.param)
      cb(res)
    }, false)
  },

  /**
   * 唤醒`app`
   * @param cb
   */
  onSystemResume (cb) {
    document.addEventListener('onSystemResume', function (res) {
      console.log('onSystemResume res: ', res.param)
      cb(res)
    }, false)
  },

  /**
   * 销毁当前页面 不能有回调
   * @param cb
   */
  onSystemDestory (cb) {
    document.addEventListener('onSystemDestory', function (res) {
      console.log('onSystemDestory res: ', res.param)
      cb(res.param)
    }, false)
  },

  /**
   * 视频状态通知监听
   * @param cb
   */
  onVideoStatusNotify (cb) {
    document.addEventListener('onVideoStatusNotify', function (res) {
      cb(res.param)
    }, false)
  },

  /**
   * `sdk`通知`js`点击事件
   * @param cb
   */
  onJSClick (cb) {
    document.addEventListener('onJSClick', function (res) {
      console.log('onJSClick res: ', res.param)
      cb(res.param)
    }, false)
  },

  /**
   * 监听横竖屏旋转
   * @param cb
   * portrait 竖屏，landscape 横屏
   */
  orientation (cb) {
    document.addEventListener('orientation', function (res) {
      console.log('orientation res: ', res.param)
      cb(res)
    }, false)
  },

  /**
   * 监听横竖屏旋转
   * @param cb
   * portrait 竖屏，landscape 横屏
   */
  webviewshow (cb) {
    document.addEventListener('webviewshow', function (res) {
      console.log('webviewshow res: ', res.param)
      cb(res)
    }, false)
  },

  /**
   * 监听安卓的`回退`按钮
   * @param cb
   */
  onSystemBackPressed (cb) {
    document.addEventListener('onSystemBackPressed', function (res) {
      cb && cb(res.param)
    }, false)
  },

  /**
   * onJSBridgeConnect
   * @param cb
   */
  onJSBridgeConnected (cb) {
    document.addEventListener('onJSBridgeConnected', function (res) {
      cb(res)
    }, false)
  },

  /**
   * ios 展示 storekit 成功或者失败
   * @param cb
   */
  storeKitShowSuccess (cb) {
    document.addEventListener('storeKitShowSuccess', function (res) {
      cb(res.param)
    }, false)
  },

  /**
   * 播放进度通知状态,progress表示当前进度如0.20,time表示当前播放时长单位秒,duration表示总时长
   * @param cb
   */
  onVideoProgressNotify (cb) {
    document.addEventListener('onVideoProgressNotify', function (res) {
      cb(res.param)
    }, false)
  },

  /**
   * IOS 主动通知 屏幕宽高和方向
   * @param cb
   */
  showDataInfo (cb) {
    document.addEventListener('showDataInfo', function (res) {
      cb(res.param)
    }, false)
  },

  /**
     * 通过reportUrls接口上报链接
     * @param {Object} params 发送的参数
     * @param {String} className sClassName，only for android
     * @param {Function} cb 成功后的回调函数
     */
  reportUrls(params, className, cb) {
    util.hybirdEvent({
        sClass: className || null,
        hybirdFn: 'reportUrls',
        params,
        succ: function (res) {
          cb && cb(res);
        },
        err: function (err) {
          console.log(err);
        }
    })
  },

  /**
     * 通过increaseOfferFrequence接口上报campaign.id数组
     * @param {Object} params 发送的参数
     * @param {String} className sClassName，only for android
     * @param {Function} cb 成功后的回调函数
     */
    sendImpressions(params, className, cb) {
      util.hybirdEvent({
          sClass: className || null,
          hybirdFn: 'increaseOfferFrequence',
          params,
          succ: function (res) {
            cb && cb(res);
          },
          err: function (err) {
            console.log(err);
          }
      })
    },

  /**
     * 传入unitId和资源组信息[{},{}]，使用getFileInfo接口获取缓存资源地址
     * @description 如果请求失败只显示err
     * @param {Object} campaignInfo 要获取资源缓存地址的campaign信息
     * @param {String} unitId 该campaign，unitSetting中的unitId
     */
    getAllSrcLocations(params, className, cb) {
      util.hybirdEvent({
          sClass: className || null,
          hybirdFn: 'getFileInfo',
          params,
          succ: (res) => {
            cb && cb(res);
          },
          err: (err) => {
            console.log(err);
          }
      });
    }
}

export default common


// WEBPACK FOOTER //
// ./src/rv/splash/common/js/common.js